import { Grid, Typography, Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Select } from '@mui/material';
import React, { useState } from 'react';
import { Translate } from 'react-localize-redux';
import { IPatient } from '../../../constants/types';
import { dateToFullDateString, formatBirthdateForDisplay, getHealthIDLabel, getPatientID } from '../../../utils';
import { useCoveragesList, useCoverage } from '../../../hooks';
import ChangeCoverageModal from './ChangeCoverageModal';
import { resolveCoverageDisplayName } from '../../../utils/coverageLabel';

interface PatientInfoProps {
    patient: IPatient,
    languageCode: string,
    canUpdateInsurance: boolean,
    isLoadingInsurance?: boolean,
    rightSide: React.ReactNode,
    onChangeCoverage?: (coverageId: number) => Promise<void>
}

const PatientInfo: React.FC<PatientInfoProps> = ({ patient, rightSide, languageCode, canUpdateInsurance, isLoadingInsurance = false, onChangeCoverage }) => {
    const [coverages, loadingCoverages] = useCoveragesList();
    const [patientCoverage, patientInsurance, loadingPatientCoverage] = patient.personalData.coverage ? useCoverage(parseInt(patient.personalData.coverage.toString())) : [null, null, false];
    const [showModal, setShowModal] = useState(false);

    const handleOpenModal = () => {
        setShowModal(true);
    };
    const handleCloseModal = () => setShowModal(false);
    const handleConfirm = async (coverageId: number) => {
        setShowModal(false);
        if (onChangeCoverage) {
            await onChangeCoverage(coverageId);
        }
    };

    return (
        <Grid container paddingBottom={'1rem'}>
            <Grid item xs={6}  >
                <Typography variant="body2"><span style={{ fontWeight: 'bold' }}><Translate id={getHealthIDLabel(patient)} /></span>: { getPatientID(patient)}</Typography>
                <Typography variant="body2"><span style={{ fontWeight: 'bold' }}><Translate id="hospital.billing.bill.patient" /></span>: {patient.personalData.name} {patient.personalData.surnames}</Typography>
                <Typography variant="body2"><span style={{ fontWeight: 'bold' }}><Translate id="investigation.create.personal_data.fields.birthdate" /></span>: {formatBirthdateForDisplay(patient.personalData.birthdate, languageCode)}</Typography>
                <Typography variant="body2"><span style={{ fontWeight: 'bold' }}><Translate id="investigation.create.personal_data.fields.sex" /></span>: {patient.personalData.sex}</Typography>
                {
                    patientCoverage &&
                    <>
                        <Typography variant="body2"><span style={{ fontWeight: 'bold' }}><Translate id="investigation.create.personal_data.fields.coverage" /></span>: {resolveCoverageDisplayName(patientCoverage, patientInsurance ? [patientInsurance] : [])}
                        {canUpdateInsurance && (
                            <Button size="small" variant="outlined" style={{ marginLeft: 8 }} onClick={handleOpenModal} disabled={isLoadingInsurance}>
                                <Translate id="hospital.billing.bill.change_coverage" />
                            </Button>
                        )}
                        </Typography>
                    </>
                }
            </Grid>
            {
                rightSide
            }
            <ChangeCoverageModal
                open={showModal}
                onClose={handleCloseModal}
                onConfirm={handleConfirm}
                coverages={coverages || []}
                currentCoverageId={patient.personalData.coverage}
                loadingCoverages={loadingCoverages}
                isConfirming={isLoadingInsurance}
            />
        </Grid>
    )
};

export default PatientInfo;
